import { CSRF_TOKEN } from "../constants";

export default (authenticated) => ({
  firstName: "",
  email: "",
  password: "",

  authenticated,
  errors: {},
  showPasswordField: false,
  loading: false,

  errorFor(field) {
    return this.errors[field]?.[0] ?? null;
  },

  async attemptAuthentication() {
    this.loading = true;
    this.errors = {};

    try {
      const response = await fetch("/authentication", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": CSRF_TOKEN,
        },
        body: JSON.stringify({
          first_name: this.firstName,
          email: this.email,
          password: this.password,
        }),
      });

      let json;
      try {
        json = await response.json();
      } catch (error) {
        alert("An unexpected error occurred.");
        this.loading = false;
        return;
      }

      if (!response.ok) {
        if (json.errors) {
          this.errors = json.errors;
        } else {
          alert(json.message || "An unexpected error occurred.");
        }

        this.loading = false;

        return;
      }

      if (json.two_factor) {
        window.location.pathname = "/two-factor-challenge";

        return;
      }

      Array.from(document.querySelectorAll("input[name=_token]")).map(
        (input) => (input.value = json.token),
      );

      this.authenticated = true;

      this.$nextTick(() => {
        this.$refs.button.form.requestSubmit(this.$refs.button);
      });
    } catch (e) {
      console.error("Authentication failed", e);
      alert("An unexpected error occurred.");
      this.loading = false;
    }
  },

  submit(event) {
    if (this.authenticated) {
      return;
    }

    if (this.loading) {
      event.preventDefault();
      return;
    }

    const form = this.$refs.button.form;
    if (!form.reportValidity()) {
      return;
    }

    event.preventDefault();
    this.attemptAuthentication();
  },
});
